import { FC } from 'react';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import HamburgerMenu from './Hamburger';
const HamburgerMenuLogic: FC = () => {
  const {
    isHamburgerOpen,
    setIsHamburgerOpen,
    setIsMenuMobileOpen
  } = headerStore(state => state);
  return <HamburgerMenu isHamburgerOpen={isHamburgerOpen} setIsHamburgerOpen={setIsHamburgerOpen} setIsMenuMobileOpen={setIsMenuMobileOpen} />;
};
export default HamburgerMenuLogic;